import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import styles from "./create-planbook.module.css"
interface Args {
  order: number
  model: {
    userId: string
  }
}

export default class CreatePlanbook extends Component<Args> {
  readonly styles = styles

  @service("ember-store") store

  @service modalManager
}
